import Model from 'flarum/common/Model';
export default class AutomationRule extends Model {
  key() {
    return Model.attribute('key').call(this);
  }
  label() {
    return Model.attribute('label').call(this);
  }
  triggerType() {
    return Model.attribute('triggerType').call(this);
  }
  triggerFields() {
    return Model.attribute('triggerFields').call(this);
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/AutomationRule', AutomationRule);